import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const eventsOnlyItem = 'Events only';
const dayRecordItem = 'Record older than a day';

const removeRecordsItems = {event: eventsOnlyItem, metric: 'Metric only', all: 'Events and metrics'};
const removalPeriodItems = {'1d': dayRecordItem, '1w': 'Record older than a week', '1m': 'Record older than a month', all: 'All'};

const EventsAndMetricsRemovedOldDialog = (props) => {
  const [removeRecordsValue, setRemoveRecordValue] = useState(eventsOnlyItem);
  const [removalPeriodValue, setRemovalPeriodValue] = useState(dayRecordItem);

  const content = () => (
    <DialogContent>
      <div className="infrastructure-expanded">
        <div className="border">
          {dialogHeader()}
          {dialogBody()}
        </div>
      </div>
    </DialogContent>
  );

  const dialogHeader = () => (
    <h2 style={{ marginTop: 0, marginBottom: 0, marginLeft: 15 }}>
      Remove old events and metrics
    </h2>
  );

  const dialogBody = () => (
    <div style={{ minWidth: '30em', marginLeft: 15, marginRight: 40 }}>
      {
        textField(
          'Remove records', removeRecordsValue, setRemoveRecordValue, removeRecordsItems
        )
      }
      <br/>
      {
        textField(
          'Period of removal', removalPeriodValue, setRemovalPeriodValue, removalPeriodItems
        )
      }
    </div>
  );

  const textField = (label, value, changeValue, menuItems) => (
    <TextField
      select
      margin="normal"
      label={label}
      value={value || '-'}
      style={{width: '100%'}}
      onChange={event => changeValue(event.target.value)}
    >
      {Object.entries(menuItems).map(([key, item]) => (<MenuItem key={key} value={item}>{item}</MenuItem>))}
    </TextField>
  )

  const footerButtons = () => (
    <DialogActions style={{paddingLeft: '24px', paddingRight: '24px', justifyContent: 'space-between'}}>
      <Button onClick={() => props.updateDialog(false)}>
        Cancel
      </Button>
      <Button variant='contained' color='primary' onClick={() => remove()}>
        Remove
      </Button>
    </DialogActions>
  );

  function remove() {
    const type = getKeyFrom(removeRecordsItems, removeRecordsValue);
    const olderThan = getKeyFrom(removalPeriodItems, removalPeriodValue);
    props.remove(type, olderThan);
    props.updateDialog(false)
  }

  function getKeyFrom(object, value) {
    let key = Object.entries(object).filter(array => array.includes(value)).map(array => array[0]).join('');
    return key !== undefined && key !== null && key !== '' ? key : 'all';
  }

  return (
    <Dialog open={props.openDialog}>
      {content()}
      {footerButtons()}
    </Dialog>
  );
}

export default React.memo(EventsAndMetricsRemovedOldDialog);
